


















import { ComponentConfig, Component, ComponentStyle, ComponentStyleDefinition } from "@zoovu/runner-browser-api";
import {
  AdvisorView,
  ColorsConfiguration,
  TopProductConfiguration,
  FontsConfiguration,
  CustomCSSConfiguration,
} from "@zoovu/runner-web-design-base";
import { CustomizedStandardTextsConfiguration } from "../configuration/customized-standard-texts-configuration";

@Component({})
export default class AdvisorViewExtended extends AdvisorView {
  public usingMouse = true;

  @ComponentStyle()
  componentStyle: ComponentStyleDefinition;

  @ComponentConfig(ColorsConfiguration)
  private colors: ColorsConfiguration;

  @ComponentConfig(FontsConfiguration)
  private fonts: FontsConfiguration;

  @ComponentConfig(CustomizedStandardTextsConfiguration)
  private standardTexts: CustomizedStandardTextsConfiguration;

  @ComponentConfig(CustomCSSConfiguration)
  private customCssConfiguration: CustomCSSConfiguration;

  @ComponentConfig(TopProductConfiguration)
  private topProductConfiguration: TopProductConfiguration;

  beforeMount(): void {
    document.body.addEventListener("mousedown", () => {
      this.usingMouse = true;
    });
    document.body.addEventListener("keydown", () => {
      this.usingMouse = false;
    });
  }
}
